import { render } from "./SocialMediaPage.vue?vue&type=template&id=2f0a1e82"
import script from "./SocialMediaPage.vue?vue&type=script&lang=js"
export * from "./SocialMediaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__